import { render, staticRenderFns } from "./ShippingRatesTab.vue?vue&type=template&id=63484002&scoped=true&"
import script from "./ShippingRatesTab.vue?vue&type=script&lang=js&"
export * from "./ShippingRatesTab.vue?vue&type=script&lang=js&"
import style0 from "./ShippingRatesTab.vue?vue&type=style&index=0&id=63484002&lang=scss&scoped=true&"
import style1 from "./ShippingRatesTab.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63484002",
  null
  
)

export default component.exports